import styles from './CoursePage.module.css';
import CourseProgressBar from "../../components/course/course-progress-bar/CourseProgressBar.tsx";
import CourseOutline from "../../components/course/course-outline/CourseOutline.tsx";
import CourseContent from "../../components/course/course-content/CourseContent.tsx";
import { useParams } from "react-router-dom";
import LessonService from "../../services/course/LessonService";
import CourseService from "../../services/course/CourseService";
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../store/store';

function CoursePage() {
    const { courseId, lessonId } = useParams();
    const isLoggedIn = useSelector((state: RootState) => state.user.isLoggedIn);
    const [lesson, setLesson] = useState(null);
    const [outline, setOutline] = useState(null);
    const [isEnrolled, setIsEnrolled] = useState(false);
    const [neighbours, setNeighbours] = useState({
        prev: null,
        next: null,
        current: 0,
        total: 0,
        chapterTitle: '',
        lessonTitle: '',
        percent: 0,
        completed: 0,
    });
    const navigate = useNavigate();
    const [drawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        LessonService.fetchLesson(courseId, lessonId).then(setLesson);
        CourseService.fetchOutline(courseId).then(setOutline);
        CourseService.fetchNextAndPrevLesson(courseId, lessonId).then(setNeighbours);
        if (isLoggedIn) {
            CourseService.isEnrolled(courseId).then(setIsEnrolled);
        }
    }, [courseId, lessonId, isLoggedIn]);

    const handlePrev = () => {
        if (neighbours.prev) navigate(`/courses/${courseId}/lessons/${neighbours.prev.id}`);
    };

    const handleNext = () => {
        if (neighbours.next) navigate(`/courses/${courseId}/lessons/${neighbours.next.id}`);
    };

    const handleComplete = () => {
        LessonService.completeLesson(courseId, lessonId).then((data) => {
            setNeighbours(prev => ({
                ...prev,
                percent: data.percent,
                completed: data.completedCount,
            }));
            // refresh outline so completed checkmark shows
            CourseService.fetchOutline(courseId).then(setOutline);

            // navigate to next page
            handleNext();
        });
    };

    const handleEnroll = () => {
        CourseService.enrollCourse(courseId).then((data) => {
            if (data.success) {
                setIsEnrolled(true);
            }
        });
    };

    return (
        <div className={styles.page}>
            <CourseProgressBar
                current={neighbours.current}
                total={neighbours.total}
                percent={neighbours.percent}
                completed={neighbours.completed}
                chapterTitle={neighbours.chapterTitle}
                lessonTitle={neighbours.lessonTitle}
                onPrev={handlePrev}
                onNext={handleNext}
                hasPrev={!!neighbours.prev}
                hasNext={!!neighbours.next}
            />
            <div className={styles.row}>
                <CourseOutline
                    courseOutline={outline}
                    activeId={Number(lessonId)}
                    percent={neighbours.percent}
                    isOpen={drawerOpen}
                    onClose={() => setDrawerOpen(false)}
                    onSelect={(id) => { navigate(`/courses/${courseId}/lessons/${id}`); setDrawerOpen(false); }}
                />
                {drawerOpen && <div className={styles.backdrop} onClick={() => setDrawerOpen(false)} />}
                <main className={styles.main}>
                    <CourseContent
                        lesson={lesson}
                        onComplete={handleComplete}
                        isEnrolled={isEnrolled}
                        onEnroll={handleEnroll}/>
                </main>
            </div>
            <button className={styles.menuToggle} onClick={() => setDrawerOpen(true)} aria-label="Open lessons">
                ☰ Lessons
            </button>
        </div>
    );
}

export default CoursePage;